export enum Alignment {
  Right = 'right',
  Left = 'left',
  Center = 'center',
}
